import { memo, useEffect, useState } from 'react';
import classes from './birthday.module.scss';

type Props = {
	birth: string;
	isFlexStart?: boolean;
};
export const BirthDay = memo((props: Props) => {
	const { birth, isFlexStart = false } = props;
	const [birthDay, setBirthDay] = useState<{ year: string; month: string; day: string }>(undefined);
	useEffect(() => {
		if (!birth) {
			return;
		}
		const date = new Date(birth);
		setBirthDay((prev) => ({
			...prev,
			year: String(date.getFullYear()),
			month: String(date.getMonth() + 1),
			day: String(date.getDate()),
		}));
	}, [birth]);

	if (!birthDay) {
		return (
			<>
				<div className={`${classes.wrap} ${isFlexStart ? classes.flexStart : classes.flexEnd}`}>
					<div className={classes.year}>
						<span className={classes.nothing}>----</span>年
					</div>
					<div className={isFlexStart ? classes.monthFix : classes.month}>
						<span className={classes.nothing}>--</span>月
					</div>
					<div className={isFlexStart ? classes.dayFix : classes.day}>
						<span className={classes.nothing}>--</span>日
					</div>
				</div>
			</>
		);
	}

	return (
		<>
			<div className={`${classes.wrap} ${isFlexStart ? classes.flexStart : classes.flexEnd}`}>
				<div className={classes.year}>{`${birthDay.year}年`}</div>
				<div className={isFlexStart ? classes.monthFix : classes.month}>{`${birthDay.month}月`}</div>
				<div className={isFlexStart ? classes.dayFix : classes.day}>{`${birthDay.day}日`}</div>
			</div>
		</>
	);
});
